export default "__VITE_ASSET__B$p0EKBc__"